import React, { useState, useEffect } from 'react'
import CloseIcon from "@material-ui/icons/Close";
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from "react-redux";
import {
    setCorrectAnswer, setCorrectAnswerNew
} from "../../../redux/action/user";
import {
    setEditCorrectAnswer,
    setEditOption
} from "../../../redux/action/Edit"
const TestAnswerBlank = (props) => {
    const dispatch = useDispatch();
    const EditState = useSelector((state) => state.Edit);

    // States
    const [title, setTitle] = useState(props.title)
    const [correct, setCorrect] = useState(props.correct)
    //Functions
    // handlechange Functions
    const HandleOnChangeInput = (e, index) => {
        setTitle(e.target.value)
        props.answerArray[props.index].title = e.target.value
        let array = props.answerArray
        props.setAnswerArray(array)
        console.log(array)
        dispatch(setCorrectAnswer(array));
        EditState.edit && dispatch(setEditOption(array));
        let correctAnswer = props.answerArray.filter(item => item.correct === true)
        EditState.edit && dispatch(setEditCorrectAnswer([correctAnswer[0].title]))
    }

    const HandleOnChangeRadio = (e) => {
        props.answerArray.map(Answer => Answer.correct = false)
        props.answerArray[props.index].correct = e.target.checked
        setCorrect(e.target.checked)
        let array = props.answerArray
        console.log(array)
        props.setAnswerArray(array)
        dispatch(setCorrectAnswer(array));
        EditState.edit && dispatch(setEditOption(array));
        let correctAnswer = props.answerArray[props.index].title
        dispatch(setCorrectAnswerNew([correctAnswer]));
        EditState.edit && dispatch(setEditCorrectAnswer([correctAnswer]))
    }
    // Add & Deletee Function

    useEffect(() => {
        setTitle(props.title)
        setCorrect(props.correct)
    }, [props.correct, props.title])



    console.log(props.id, "props.idprops.idprops.idprops.idprops.idprops.id")

    return (
        <>
            <div className="BlankAnswer container">
                <div className="row">

                    <div className="col-12">
                        <div className="d-flex justify-content-center align-items-center">
                            <button
                                className="btn"
                                onClick={() => props.DeleteAnswer(title, props.id)}
                            >
                                <CloseIcon color="secondary" />
                            </button>
                            <TextField
                                className="Input_class"
                                onChange={(e) => HandleOnChangeInput(e)}
                                id="outlined-basic"
                                label={<p className="text_bold">پاسخ سوال</p>}
                                variant="outlined"
                                name={props.title}
                                value={title}
                            />
                            <label className="main-change-radio">
                                <input
                                    type="radio"
                                    onChange={(e) => HandleOnChangeRadio(e)}
                                    name="radio"
                                    value={correct ? true : false}
                                    checked={correct ? true : false}
                                />
                                <span className="checkmark"></span>
                            </label>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TestAnswerBlank
